import posthog from 'posthog-js';
import { config } from '@/config';
import { registerCapture } from '@codemerlin/shared/analytics';

let isInitialized = false;
let isEnabled = false;

export const initializeAnalytics = () => {
  if (config.posthogKey && !isInitialized) {
    posthog.init(config.posthogKey, {
      api_host: config.posthogHost,
      defaults: '2025-11-30',
      capture_pageview: false, // We'll handle this manually after consent for SPA routes
      opt_out_capturing_by_default: true,
      persistence: 'localStorage',
      autocapture: true,
    });
    isInitialized = true;
  }

  return posthog;
};

export const enableAnalytics = () => {
  initializeAnalytics();

  if (config.posthogKey) {
    posthog.opt_in_capturing?.();
    isEnabled = true;
    registerCapture((event, properties) => posthog.capture(event, properties));
  }
};

export const disableAnalytics = () => {
  initializeAnalytics();

  if (!config.posthogKey || !isInitialized) return;

  posthog.opt_out_capturing?.();
  isEnabled = false;
  registerCapture(null);
};

export const analytics = {
  capture: (event: string, properties?: Record<string, unknown>) => {
    if (config.posthogKey && isInitialized && isEnabled) {
      posthog.capture(event, properties);
    }
  },
  captureException: (error: unknown, properties?: Record<string, unknown>) => {
    if (!config.posthogKey || !isInitialized || !isEnabled) return;

    if (typeof posthog.captureException === 'function' && error instanceof Error) {
      posthog.captureException(error, properties);
      return;
    }

    posthog.capture('frontend_error', {
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      ...properties,
    });
  },
  identify: (userId: string, properties?: Record<string, unknown>) => {
    if (config.posthogKey && isInitialized && isEnabled) {
      posthog.identify(userId, properties);
    }
  },
  reset: () => {
    if (config.posthogKey && isInitialized) {
      posthog.reset();
    }
  },
};
